<template>
  <div class="sidebar-detached sidebar-left">
    <div class="sidebar">
      <div
        class="sidebar-shop"
        :class="{
          'show': mqShallShowLeftSidebar,
          'bg-light': mqShallShowLeftSidebar && $store.state.appConfig.layout.skin === 'light',
          'bg-dark': mqShallShowLeftSidebar && $store.state.appConfig.layout.skin === 'dark',
        }"
      >

        <b-card-actions
          action-collapse
          :title="$t('Benchmark')"
          :collapsed="false"
          class="text-right"
        >
          <feather-icon
            id="popover-1-bench"
            icon="InfoIcon"
            class="mb-1"
            title="Test"
          />
          <b-popover
            target="popover-1-bench"
            placement="left"
            triggers="hover focus"
          >
            {{ $t('Color code in correlation with selected Benchmark') }}<br>
            <span class="text-primary">{{ $t('Blue = equal or better') }}</span><br>
            <span class="text-danger">{{ $t('Red = worse') }}</span>
          </b-popover>
          <v-select
            id="benchmark"
            v-model="$store.state.spider.playerBenchmark"
            :placeholder="$t('No benchmark')"
            :reduce="o => $store.state.spider.playerBenchmarks.indexOf(o)"
            :options="$store.state.spider.playerBenchmarks"
            :clearable="false"
            @input="updateGraph"
          />
        </b-card-actions>

        <b-card
          :title="$t('Filters')"
        >
          <h4 class="left-filter-title">
            {{ $t('Options') }}
          </h4>

          <label
            for="speed"
          >{{ $t('Green Speed') }}</label>
          <v-select
            id="speed"
            v-model="filters.greenspeed"
            label="text"
            :reduce="o => o.value"
            :options="filterOptions.greenspeed"
            :clearable="false"
          />
          <label
            for="rain"
          >{{ $t('Rain') }}</label>
          <v-select
            id="rain"
            v-model="filters.rain"
            label="text"
            :reduce="o => o.value"
            :options="filterOptions.rain"
            :clearable="false"
          />
          <label
            for="wind"
          >{{ $t('Wind') }}</label>
          <v-select
            id="wind"
            v-model="filters.wind"
            label="text"
            :reduce="o => o.value"
            :options="filterOptions.wind"
            :clearable="false"
          />
          <label
            for="temperature"
          >{{ $t('Temperature') }}</label>
          <v-select
            id="temperature"
            v-model="filters.temperature"
            label="text"
            :reduce="o => o.value"
            :options="filterOptions.temperature"
            :clearable="false"
          />

          <h4 class="left-filter-title">
            {{ $t('Full Rounds') }}
          </h4>

          <b-button-group class="mb-1">
            <b-button
              v-for="btn in filterOptions.holesNumber"
              :key="btn.value"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              :pressed="btn.value === filters.holesNumber"
              @click="filters.holesNumber = btn.value"
            >
              {{ btn.text }}
            </b-button>

          </b-button-group><br />

          <!-- <div class="d-flex mb-1">
            <b-form-checkbox
              id="holesSwitch"
              v-model="filters.holesNumber"
              name="price-switch"
              :value="filterOptions.holesNumber[1].value"
              :unchecked-value="filterOptions.holesNumber[0].value"
              switch
            />
            <h6
              v-if="filters.holesNumber === filterOptions.holesNumber[1].value"
              class="mb-0"
            >
              {{ filterOptions.holesNumber[1].text }}
            </h6>
            <h6
              v-else
              class="mb-0"
            >
              {{ filterOptions.holesNumber[0].text }}
            </h6>
          </div> -->
          <!-- <div class="d-flex mb-1">
            <b-form-checkbox
              id="fullSwitch"
              v-model="filters.shotByShot"
              name="price-switch"
              :value="filterOptions.shotByShot[1].value"
              :unchecked-value="filterOptions.shotByShot[0].value"
              switch
            />
            <h6
              v-if="filters.shotByShot === filterOptions.shotByShot[1].value"
              class="mb-0"
            >
              {{ filterOptions.shotByShot[1].text }}
            </h6>
            <h6
              v-else
              class="mb-0"
            >
              {{ filterOptions.shotByShot[0].text }}
            </h6>
          </div> -->

          <label
            for="qualification"
          >{{ $t('Type') }}</label>
          <v-select
            id="qualification"
            v-model="filters.qualification"
            label="text"
            :reduce="o => o.value"
            :options="filterOptions.qualification"
            :clearable="false"
          />
          <label
            v-if="filters.qualification === 2"
            for="competition"
          >{{ $t('Tournament round') }}</label>
          <v-select
            v-if="filters.qualification === 2"
            id="competition"
            v-model="filters.competition"
            label="text"
            :reduce="o => o.value"
            :options="filterOptions.competition"
            :clearable="false"
          />

          <label
            for="roundType"
          >{{ $t('Select Rounds') }}</label>
          <v-select
            id="roundType"
            v-model="filters.roundType"
            label="text"
            :reduce="o => o.value"
            :options="filterOptions.roundType"
            :clearable="false"
          />

          <h4 class="left-filter-title">
            {{ $t('Date range') }}
          </h4>
          <label
            for="datepicker-start"
          >{{ $t('From') }}</label>
          <b-form-datepicker
            id="datepicker-start"
            v-model="filters.startDate"
            v-bind="labels[$i18n.locale] || {}"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            reset-button
            :locale="$i18n.locale"
          />
          <label
            for="datepicker-end"
          >{{ $t('To') }}</label>
          <b-form-datepicker
            id="datepicker-end"
            v-model="filters.endDate"
            v-bind="labels[$i18n.locale] || {}"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            reset-button
            :locale="$i18n.locale"
          />

        </b-card>

      </div>
    </div>

    <div
      class="body-content-overlay"
      :class="{'show': mqShallShowLeftSidebar}"
      @click="$emit('update:mq-shall-show-left-sidebar', false)"
    />
  </div>
</template>

<script>
import {
  BFormDatepicker, BCard, BPopover, BButton, BButtonGroup,
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
// import { getUserData } from '@/auth/utils'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    // BFormCheckbox,
    BCardActions,
    BCard,
    BFormDatepicker,
    vSelect,
    BPopover,
    BButton,
    BButtonGroup,
  },
  directives: {
    Ripple,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    filterOptions: {
      type: Object,
      required: true,
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    key1: {
      type: String,
      required: true,
    },
    key2: {
      type: String,
      required: true,
    },
    playerId: {
      type: Number,
      required: false,
      default: null,
    },

  },
  data() {
    return {
      labels: {
        fr: {
          weekdayHeaderFormat: 'narrow',
          labelPrevDecade: 'Décennie précédente',
          labelPrevYear: 'Année précédente',
          labelPrevMonth: 'Mois précédent',
          labelCurrentMonth: 'Mois en cours',
          labelNextMonth: 'Prochain mois',
          labelNextYear: 'Année prochaine',
          labelNextDecade: 'Prochaine décennie',
          labelToday: 'Aujourd\'hui',
          labelSelected: 'Selectionnée',
          labelNoDateSelected: 'Pas de date choisie',
          labelCalendar: 'Calendrier',
          labelNav: 'Navigation',
          labelHelp: 'Utilisez les flèches du clavier pour nagviguer',
        },
      },
    }
  },
  methods: {
    clearPlayers() {
      this.filters.selectedPlayers = []
    },
    updateGraph() {
      this.$emit('update')
      // this.$store.commit('spider/updateplayerStats', this.playerId ? +this.playerId : getUserData().user_id)
      // this.$store.commit('spider/updateGraph', { title: this.title, key1: this.key1, key2: this.key2 })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss" scoped>
.categories-radio-group,
.brands-radio-group,
.price-range-defined-radio-group {
    ::v-deep > .custom-control {
    margin-bottom: 0.75rem;
  }
}
.hide-header{
  display: none;
}
.left-filter-title{
  font-size: 17px;
  margin: 1rem 0;
  font-weight: bold;
}
</style>
